import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatDate } from '@/util/formatDate';
import { TypeFormatDate } from '@/common/enums/general/TypeFormatDate';

export const LocalDateTimeInterceptor : HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    if (req.body && typeof req.body === 'object') {
        const newBody = convertDates(req.body);
        const cloned  = req.clone({ body: newBody });
        return next(cloned);
    }
    return next(req);
};

function convertDates(value: any): any {
  if (value instanceof Date) {
    return formatDate(value, TypeFormatDate.API_DATETIME);
  }

  if (Array.isArray(value)) {
    return value.map(v => convertDates(v));
  }

  if (value && typeof value === 'object') {
    const clone: any = {};
    Object.keys(value).forEach(k => {
      clone[k] = convertDates(value[k]);
    });
    return clone;
  }

  return value;
}
